import HeroBgI from "../../img/hero-bg.png";
import LogoI from "../../img/logo.png";
import NotFoundI from "../../img/NotFound.svg";
// Showcase Banner Static Assets

// Exports
export const Logo = LogoI;
export const HeroBg = HeroBgI;
export const NotFoundImg = NotFoundI;
